import api from "./api";

export async function fetchDashboardCategories(params = {}) {
  const response = await api.get("/categories", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
